import type { LicensingRuleType, PolicyAction } from '../../../../shared/model-typings';

export const licensingRuleTypeToAction = (type: LicensingRuleType): PolicyAction => {
  switch (type) {
    case 'denied_license':
      return 'DENY';
    case 'flagged_license':
      return 'FLAG';
    case 'approved_license':
    default:
      return 'APPROVE';
  }
};
